import { Backdrop as MUIBackdrop, BackdropProps as MUIBackdropProps } from '@mui/material';
import classnames from 'classnames';
import { mergeSX } from '../../services/helpers';

const buildSX = () => ({
  '&.MuiBackdrop-root': {
    backdropFilter: 'blur(10px)',
  },
  '&.primary': {
    background: 'rgba(196, 196, 196, 0.16);', // white
  },
  '&.secondary': {
    background: 'rgba(51, 51, 51, 0.7);', // dark
  },
});

export interface IBackdropProps extends MUIBackdropProps {
}

const Backdrop = (props: IBackdropProps) => {
  const {
    children, className, sx, ...restProps
  } = props;
  return (
    <MUIBackdrop
      {...restProps}
      className={classnames(className, 'primary')}
      sx={mergeSX(buildSX(), sx)}
    >
      {children}
    </MUIBackdrop>
  );
};

export const BackdropSecondary = (props: IBackdropProps) => {
  const {
    children, className, sx, ...restProps
  } = props;
  return (
    <MUIBackdrop
      {...restProps}
      className={classnames(className, 'secondary')}
      sx={mergeSX(buildSX(), sx)}
    >
      {children}
    </MUIBackdrop>
  );
};
export default Backdrop;
